export default "__VITE_ASSET__Bp95RPaH__"